export class EmailSet {
  Address: string;
  DisplayName: string;
}
